module.exports = __webpack_public_path__ + "img/icon3.eebc3d9b.png";